import { boundApiRequest } from "./utils"

export type IApiGetBranch = {
  id: string
  name: string
  lastOrderExportAt: Date | null
  lastImportAt: Date | null
}

export async function getBranch(id: string) {
  return await boundApiRequest<IApiGetBranch>(`/branches/${id}`)
}
